export const OCC_ENDPOINTS = {
  trackingPickup: '/track/${orderGuid}',
};
